// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1dafV","header":"ClearentDisclaimer_header__1oA7n","inner":"ClearentDisclaimer_inner__3nGna"};